/**
 * Debug logging for CBE / test environments (visible via vConsole in SuperApp WebView).
 */

export function isTestEnvironment(): boolean {
  if (typeof window === "undefined") {
    return Boolean(import.meta.env.DEV)
  }

  if (import.meta.env.DEV) return true
  if (import.meta.env.MODE !== "production") return true
  if (import.meta.env.VITE_ENABLE_VCONSOLE === "true") return true

  const host = window.location.hostname.toLowerCase()
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.includes("test") ||
    host.includes("beta") ||
    host.includes("uat") ||
    host.includes("staging")
  )
}

const PREFIX = "[CBE Payment]"

export function cbeDebugLog(...args: unknown[]): void {
  console.log(PREFIX, ...args)
}

export function cbeDebugWarn(...args: unknown[]): void {
  console.warn(PREFIX, ...args)
}

export function cbeDebugError(...args: unknown[]): void {
  console.error(PREFIX, ...args)
}

/** Mask long secrets in logs while keeping enough to verify presence */
export function maskSecret(value: unknown, keep = 8): string {
  if (value == null || value === "") return "(none)"
  const s = String(value)
  if (s === "undefined" || s === "null") return "(none)"
  if (s.length <= keep * 2) return `${s.slice(0, 4)}…`
  return `${s.slice(0, keep)}…${s.slice(-4)} (len=${s.length})`
}
